import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {
  transform(records: Array<any>, args?: any): any {
    // Return records if null or empty
    if (!records || records.length === 0) {
      return records;
    }
    // Return records if args or args.property is missing
    if (!args || !args.property) {
      return records;
    }
    return records.sort((a, b) => {
      // Safely get values, defaulting to null if property is missing or a/b is null
      const aValue = a ? a[args.property] : null;
      const bValue = b ? b[args.property] : null;
      // Handle null or undefined values for comparison
      if (aValue === null || aValue === undefined) {
        return (bValue === null || bValue === undefined) ? 0 : (args.direction * -1); // Push nulls to end if bValue exists, else equal
      }
      if (bValue === null || bValue === undefined) {
        return args.direction; // Push nulls to end if aValue exists
      }
      if (args.isDateSort) {
        const aDate = new Date(aValue);
        const bDate = new Date(bValue);
        // Check for valid dates
        const aDateValid = !isNaN(aDate.getTime());
        const bDateValid = !isNaN(bDate.getTime());
        if (aDateValid && bDateValid) {
          return (aDate.getTime() < bDate.getTime() ? -1 : (aDate.getTime() > bDate.getTime() ? 1 : 0)) * args.direction;
        } else {
          // If dates are invalid, compare as strings (case-insensitive, numeric)
          const aString = String(aValue || '').toLocaleLowerCase();
          const bString = String(bValue || '').toLocaleLowerCase();
          return aString.localeCompare(bString, undefined, { numeric: true, sensitivity: 'base' }) * args.direction;
        }
      } else {
        // For non-date sort, compare as strings
        const aString = String(aValue || '').toLocaleLowerCase();
        const bString = String(bValue || '').toLocaleLowerCase();
        return aString.localeCompare(bString, undefined, { numeric: true, sensitivity: 'base' }) * args.direction;
      }
    });
  }
}